import BaseReducer from "./BaseReducer";

class OfficerFormModalReducer extends BaseReducer {
  domain = "OfficerForm";
  type = "Modal";

  initialState = {
    open: false,
    title: "Add Officer",
    searchQuery: "",
    // The currently selected officer type
    officerType: 1,
    isEnforcementPolice: false,
    // The officer type options meta data
    officerTypes: null,
    loadingOfficerTypes: false,
    officerFormData: {
      name: "",
      badgeNumber: "",
      stationName: "",
      phoneNumber: "",
      address1: "",
      address2: "",
      town: "",
      postcode: "",
    },
  };
}

const reducer = new OfficerFormModalReducer();

export default reducer;
